import React, { createContext, useContext, useState, useCallback } from 'react';
import { apiRequest } from '../utils/api';

const UsageContext = createContext();

export const useUsage = () => {
  const context = useContext(UsageContext);
  if (!context) {
    throw new Error('useUsage must be used within a UsageProvider');
  }
  return context;
};

export const UsageProvider = ({ children }) => {
  const [usage, setUsage] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUsage = useCallback(async () => {
    try {
      setLoading(true);
      
      const subscriptionData = await apiRequest('subscription/current').catch((err) => {
        console.error('Subscription fetch failed:', err);
        return null;
      });
      
      const usageData = await apiRequest('subscription/usage').catch((err) => {
        console.error('Usage fetch failed:', err);
        return null;
      });
      
      if (subscriptionData) {
        setSubscription(subscriptionData);
      }
      
      if (usageData) {
        setUsage(usageData);
      }
      
      return { subscription: subscriptionData, usage: usageData };
    } catch (error) {
      console.error('Failed to fetch usage data:', error);
      return { subscription: null, usage: null };
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshUsage = useCallback(async () => {
    return await fetchUsage();
  }, [fetchUsage]);

  const value = {
    usage,
    subscription,
    loading,
    fetchUsage,
    refreshUsage
  };

  return (
    <UsageContext.Provider value={value}>
      {children}
    </UsageContext.Provider>
  );
};
